import React, { useEffect, useState } from "react";
import { fetchFeatured } from "@/lib/featuredPro";
import { FeaturedSpotlight } from "@/components/featured/FeaturedSpotlight";

const PLACEMENT = "CONNECTIONS_PROFESSIONAL_SPOTLIGHT";

/* Connections → Discover Professionals featured section. Promoted placement is rendered
   ABOVE and separately from organic directory results, relevance-ranked by the visitor's
   filters (server-side). Renders nothing (and reports no inventory) when none are live. */
export function FeaturedProfessionalSpotlight({ onInventory, filters = {}, renderAction }) {
  const [items, setItems] = useState([]);
  const { q = "", role = "any", city = "" } = filters;

  useEffect(() => {
    const params = { placement: PLACEMENT };
    if (q.trim()) params.q = q.trim();
    if (role && role !== "any") params.role = role;
    if (city.trim()) params.city = city.trim();
    const t = setTimeout(() => {
      fetchFeatured(params)
        .then((list) => { setItems(list); onInventory?.(list.length > 0); })
        .catch(() => { setItems([]); onInventory?.(false); });
    }, 300);
    return () => clearTimeout(t);
  }, [q, role, city]); // eslint-disable-line

  if (!items.length) return null;
  return (
    <FeaturedSpotlight tid="connections-featured-section" placement={PLACEMENT} items={items} renderAction={renderAction}
      className="mb-6 rounded-3xl" inner="px-4 py-3.5 sm:px-6 sm:py-4"
      subtitle="Promoted professionals across the PropertyConnect network" />
  );
}

export default FeaturedProfessionalSpotlight;
